import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function FooterSection() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navItems = [
    { labelKey: "footer.navAbout", id: "about" },
    { labelKey: "footer.navApproach", id: "tagline" },
    { labelKey: "footer.navContact", id: "contact" },
  ];

  return (
    <footer className="bg-[#EBF2EE] border-t border-[#D4E3DC] py-16 px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-14">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/393595e6-d208-41ce-a3f5-17096d7bbb19.png"
              alt="ExoMed"
              className="h-9 w-auto object-contain mb-4"
            />
            <p
              className="text-[#5A5A54] text-[14px] leading-relaxed font-light max-w-xs"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("footer.description")}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4
              className="text-[11px] tracking-[0.22em] uppercase text-[#3D6B5A] font-medium mb-5"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              <a href="#about">{t("footer.navigation")}</a>
            </h4>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-[#5A5A54] text-[14px] font-light hover:text-[#3D6B5A] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {t(item.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-[11px] tracking-[0.22em] uppercase text-[#3D6B5A] font-medium mb-5"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              <a href="#contact">{t("footer.contactTitle")}</a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:kontakt@exomed.no"
                  className="flex items-center gap-2.5 text-[#5A5A54] text-[14px] font-light hover:text-[#3D6B5A] transition-colors duration-200 cursor-pointer"
                  rel="nofollow"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  <i className="ri-mail-line text-[#3D6B5A] text-base" />
                  kontakt@exomed.no
                </a>
              </li>
              <li>
                <a
                  href="tel:51535153"
                  className="flex items-center gap-2.5 text-[#5A5A54] text-[14px] font-light hover:text-[#3D6B5A] transition-colors duration-200 cursor-pointer"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  <i className="ri-phone-line text-[#3D6B5A] text-base" />
                  51 53 51 53
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#C8D8D3] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-[#9B9A94] text-[13px] font-light"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            &copy; {currentYear} {t("footer.rights")}
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/personvern"
              className="text-[#9B9A94] text-[13px] font-light hover:text-[#3D6B5A] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("footer.privacy")}
            </Link>
            <span className="text-[#C8D8D3] text-[13px]">&middot;</span>
            <p
              className="text-[#9B9A94] text-[13px] font-light"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("footer.tagline")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
